import { ref, reactive, onMounted } from '@vue/runtime-core';
import useVuelidate from '@vuelidate/core';
import { resolveComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, createBlock, createCommentVNode } from 'vue';

var script = {
  name: 'PersonalData',
  props:{
    rulesValidationPersonal:{
      typeof:Array,
      value:function (){ return []; }
    },
    listQuestionPersonal:{
      typeof:Array,
      value:function (){ return []; }
    },
    classContainer:{
      typeof:String,
      value:function (){ return ""; }
    },
    modelPersonal:{
      typeof:Object,
      value:function (){}
    },
    ClassInputsQuestion:{
      typeof:String,
      value:function (){ return ""; }
    },
    ClassContainerQuestion:{
      typeof:String,
      value:function (){ return ""; }
    },
    ShowPlasceholderQuestion:{
      typeof:Boolean,
      value:function (){ return false; }
    },
    ClassErrorsContainerQuestion:{
      typeof:String,
      value:function (){ return ""; }
    },
    ClassErrorsTextQuestion:{
      typeof:String,
      value:function (){ return ""; }
    },
  },
  setup: function setup(props){
    var _listQuestionPersonal=ref([]);
    var _classContainer=ref();
    var InputReactiveFormSimpleRef=ref(null);
    var rulesValidationPersonal=reactive(props.rulesValidationPersonal);
    var _modelPersonal=reactive(props.modelPersonal);
    var classInputsQuestion=ref("");
    var classContainerQuestion=ref("");
    var showPlasceholderQuestion=ref(false);
    var rulesValidationPersonal$ = useVuelidate(rulesValidationPersonal,_modelPersonal);
    var classErrorsContainerQuestion=ref("");
    var classErrorsTextQuestion=ref("");
    onMounted(function (){
      try{
        _classContainer.value=props.classContainer;
        classInputsQuestion.value=props.ClassInputsQuestion;
        classContainerQuestion.value=props.ClassContainerQuestion;
        showPlasceholderQuestion.value=props.ShowPlasceholderQuestion;
        classErrorsContainerQuestion.value=props.ClassErrorsContainerQuestion;
        classErrorsTextQuestion.value=props.ClassErrorsTextQuestion;
        _listQuestionPersonal.value=(is_prop_empty("listQuestionPersonal"))==true?get_data_of_prop("listQuestionPersonal"):[];
      }
      catch(ex){
        console.log("Error in componente Personal data ==>",ex);
      }
    });
    function is_prop_empty(nodeOfprop){
      if(props[nodeOfprop]==undefined || props[nodeOfprop]==null || props[nodeOfprop].length==0){
        return false;
      }
      return true;
    }
    
    var get_data_of_prop=function (nodeOfprop){ return props[nodeOfprop]; }; 
    function get_personal_data(perosnalData){
      var this$1$1 = this;

      if(_listQuestionPersonal.value.length>0){
        perosnalData.map(function (element){
           _modelPersonal[element.node_name] = element.response;
           if(element.is_touched){
              element.errors = this$1$1.rulesValidationPersonal$[element.node_name].$errors;
              this$1$1.rulesValidationPersonal$[element.node_name].$touch();
            }
          });
      }
    }
    function execute_validation_form(){
      var this$1$1 = this;

      _listQuestionPersonal.value.map(function (element){
        element.errors = this$1$1.rulesValidationPersonal$[element.node_name].$errors;
        this$1$1.rulesValidationPersonal$[element.node_name].$touch();
      });
    }
      return {
        get_personal_data: get_personal_data,
        _listQuestionPersonal: _listQuestionPersonal,
        _classContainer: _classContainer,
        InputReactiveFormSimpleRef: InputReactiveFormSimpleRef,
        rulesValidationPersonal$: rulesValidationPersonal$,
        _modelPersonal: _modelPersonal,
        execute_validation_form: execute_validation_form,
        classInputsQuestion: classInputsQuestion,
        classContainerQuestion: classContainerQuestion,
        showPlasceholderQuestion: showPlasceholderQuestion,
        classErrorsContainerQuestion: classErrorsContainerQuestion,
        classErrorsTextQuestion: classErrorsTextQuestion
      }
  },
   watch:{
    "_modelPersonal":{
      handler: function handler(data){
        this.rulesValidationPersonal$.$validate();
        if(!this.rulesValidationPersonal$.$error){
          this.$emit("return-personal-data",data);
        }
        else {
          return this.$emit("return-personal-data",new Object({})) ;
        }
      },
      deep:true
    }
  },
};

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputReactiveFormSimple = resolveComponent("InputReactiveFormSimple");

  return (openBlock(), createElementBlock("div", null, [
    createElementVNode("div", {
      class: normalizeClass($props.classContainer)
    }, [
      ($setup._listQuestionPersonal.length>0)
        ? (openBlock(), createBlock(_component_InputReactiveFormSimple, {
            ListQuestions: $setup._listQuestionPersonal,
            ref: "InputReactiveFormSimpleRef",
            onReturnDataForm: _cache[0] || (_cache[0] = function ($event) { return ($setup.get_personal_data($event)); }),
            key: $setup._listQuestionPersonal,
            ClassInputs: $setup.classInputsQuestion,
            ClassContainer: $setup.classContainerQuestion,
            ShowPlasceholder: $setup.showPlasceholderQuestion,
            ClassErrorsContainer: $setup.classErrorsContainerQuestion,
            ClassErrorsText: $setup.classErrorsTextQuestion
          }, null, 8 /* PROPS */, ["ListQuestions", "ClassInputs", "ClassContainer", "ShowPlasceholder", "ClassErrorsContainer", "ClassErrorsText"]))
        : createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ]))
}

script.render = render;
script.__file = "src/PersonalData.vue";

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return; }
	install.installed = true;
	Vue.component('PersonalData', script);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export { script as default, install };
